var _style, _g, _rect, _polygon, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3600 3600",
    style: {
      enableBackground: "new 0 0 3600 3600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M738,3550.5l1118.2-1118.2l1118.2,1118.2c32.2,32.3,75.4,49.4,119.4,49.4c21.7,0,43.7-4.2,64.5-12.9 c63.1-26.1,104.2-87.6,104.2-155.9V168.7C3262.5,75.5,3187,0,3093.8,0h-2475c-93.2,0-168.7,75.5-168.7,168.7v3262.4 c0,68.3,41.1,129.8,104.1,155.9C617.3,3613.4,689.9,3598.8,738,3550.5L738,3550.5z M787.5,337.6h2137.4V3024l-949.4-949.4 c-33-33-76.1-49.4-119.3-49.4c-43.2,0-86.4,16.5-119.3,49.4L787.5,3024V337.6z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 689.9,
    y: 184.3,
    className: "st0",
    width: 2357.9,
    height: 2212.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2122.4,2120.2 2649.3,1800 3242.9,2882 2716,3202.1 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 399.7,
    y: 2134.9,
    transform: "matrix(0.5588 -0.8293 0.8293 0.5588 -1548.5114 1967.5533)",
    className: "st0",
    width: 1350.5,
    height: 608.4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilled);
export default __webpack_public_path__ + "static/media/bookmarkFilled.7c5626b6294f4c1c60afed6d38397169.svg";
export { ForwardRef as ReactComponent };